/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface ParamsProps {
  body: {
    idLead: string | null;
    dataNascimento: string | null;
    observacoes: string | null;
    idSexo: string | null;
    idProfissao: string | null;
    cpf: string | null;
    idEstadoCivil: string | null;
    idRendaFamiliar: string | null;
    cep: string | null;
    bairro: string | null;
    cidade: string | null;
    idObjetivoCompra: string | null;
    logradouro: string | null;
    complementoEndereco?: string | null;
  };
  idLeadCorretor: string | null;
}

export function useAlterarDadosComplementares(params: ParamsProps | null) {
  // eslint-disable-next-line no-promise-executor-return
  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
  const updateData = async () => {
    const ALTERAR_DADOS_COMPLEMENTARES = `${leadsWebEnviroment}/app-web/leads/alterar-dados-complementares/v1/${params?.idLeadCorretor}`;
    return await instance.put(ALTERAR_DADOS_COMPLEMENTARES, params?.body);
  };
  const query = useMutation({
    mutationFn: async () => await updateData(),
    mutationKey: ["alterar_dados_complementares"],
    onError: (error: any) => {
      toast?.error(
        `Erro ao atualizar dados complementares. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
    onSuccess: async () => {
      toast.success("Dados complementares atualizados com sucesso.", {
        autoClose: 10000,
      });
      await delay(3000);
    },
  });
  return query;
}
